"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.getFlexBaseQuery = void 0;
var query_1 = require("@reduxjs/toolkit/query");
var utils_1 = require("./utils");
var config_1 = require("../config");
var device_metadata_1 = require("../device-metadata");
var embed_1 = require("../embed");
var getFlexBaseQuery = function (_a) {
    var baseUrlArg = _a.baseUrl, getAuthToken = _a.getAuthToken, version = _a.version, versionName = _a.versionName, platform = _a.platform, handleAuthTokenRefresh = _a.handleAuthTokenRefresh, onFlexApiError = _a.onFlexApiError, onHttpError = _a.onHttpError, onSuccess = _a.onSuccess;
    return function (fetchArgs, queryApi, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
        function makeCall(token) {
            var reduxState = queryApi.getState();
            var baseUrl = reduxState.config.baseUrl || baseUrlArg;
            if (!baseUrl) {
                throw new Error('No base URL configured in state or passed in Flex API');
            }
            var baseQuery = (0, query_1.fetchBaseQuery)({
                baseUrl: baseUrl,
                mode: 'cors',
                validateStatus: function (_, body) { return body === null || body === void 0 ? void 0 : body.ok; },
                prepareHeaders: function (headers) {
                    var _a, _b, _c, _d;
                    return __awaiter(this, void 0, void 0, function () {
                        var authToken, _e;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0:
                                    headers.set('X-Flex-App-Version', version);
                                    headers.set('X-Flex-App-Platform', platform);
                                    headers.set('X-Flex-App-Version-Name', versionName);
                                    headers.set('X-Flex-App-Device-Id', ((_a = reduxState.deviceMetadata) === null || _a === void 0 ? void 0 : _a.deviceId) || '');
                                    headers.set('X-Flex-App-Source', ((_b = reduxState.embed) === null || _b === void 0 ? void 0 : _b.isEmbed) ? 'embed' : 'flex');
                                    if ((_c = reduxState.embed) === null || _c === void 0 ? void 0 : _c.isEmbed) {
                                        headers.set('X-Flex-App-Embed-Source', (_d = reduxState.embed) === null || _d === void 0 ? void 0 : _d.client);
                                    }
                                    _e = token;
                                    if (_e) return [3 /*break*/, 2];
                                    return [4 /*yield*/, getAuthToken()];
                                case 1:
                                    _e = (_f.sent());
                                    _f.label = 2;
                                case 2:
                                    authToken = _e;
                                    if (authToken) {
                                        headers.set('Authorization', "Bearer ".concat(authToken));
                                    }
                                    return [2 /*return*/, headers];
                            }
                        });
                    });
                }
            });
            return baseQuery(fetchArgs, queryApi, extraOptions);
        }
        var result, newToken;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, makeCall()
                    // Error coming from Flex
                ];
                case 1:
                    result = _f.sent();
                    // Error coming from Flex
                    if ((0, utils_1.isApiError)(result.error)) {
                        onFlexApiError({
                            endpoint: queryApi.endpoint,
                            error: result.error.data.error,
                            type: queryApi.type,
                            requestId: (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.request_id
                        });
                        // Error coming from HTTP issue (timeout, 404, etc.)
                    }
                    else if (result.error) {
                        onHttpError({
                            endpoint: queryApi.endpoint,
                            error: result.error.status,
                            type: queryApi.type
                        });
                        // Successful request
                    }
                    else {
                        onSuccess({
                            endpoint: queryApi.endpoint,
                            requestId: (_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.request_id,
                            type: queryApi.type
                        });
                    }
                    if (!(((_e = result.error) === null || _e === void 0 ? void 0 : _e.status) === 401)) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleAuthTokenRefresh()];
                case 2:
                    newToken = _f.sent();
                    return [2 /*return*/, makeCall(newToken)];
                case 3: return [2 /*return*/, result];
            }
        });
    }); };
};
exports.getFlexBaseQuery = getFlexBaseQuery;
